import { css } from '@emotion/react'

import { size } from '@twisto/styles'

export const subcategoryList = css`
  gap: clamp(${size[48]}, 2vw + ${size[32]}, ${size[64]});
`

export const section = css`
  width: 100%;
`
